import ConfirmModal from '../UI/Modal/confirmModal';
import { toast } from 'react-toastify';
import { useState } from 'react';
import { deleteNotification } from '../../utils/APIs';
import { useUserContext } from '../../contexts/UserContext';
import { useContentfulContext } from '../../contexts/ContentfulContext';

const DeleteNotificationModal = ({ setSelectedAction, selectedNotification, setSelectedNotification, getNotifications }) => {
    const [loading, setLoading] = useState(false);
    const { userData } = useUserContext()
    const { content } = useContentfulContext();

    const handleDelete = async () => {
        setLoading(true);
        try {
            await deleteNotification(userData?.token, selectedNotification._id, userData.selectedOrganization.org_token, "global");
            toast.success(content.ADMIN_NOTIFICATIONS.delete_modal.success_msg);
            getNotifications();
            setSelectedNotification(null)
            setSelectedAction('');
        } catch (error) {
            toast.error(content.ADMIN_NOTIFICATIONS.delete_modal.error_msg);
            console.error('Delete notification error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <ConfirmModal
            title={content.ADMIN_NOTIFICATIONS.delete_modal.title}
            description={content.ADMIN_NOTIFICATIONS.delete_modal.description}
            ConfirmText={content.ADMIN_NOTIFICATIONS.delete_modal.delete_cta_text}
            loading={loading}
            hideModal={() => setSelectedAction('')}
            handleConfirmation={handleDelete}
        />
    );
};

export default DeleteNotificationModal;
